module.exports = __webpack_public_path__ + "static/social_ads-8842c44f3f83175961cfb53b854dc965.jpg";